import { YHImport } from '@/components/YHImport'
import { useJoinIntention } from '../intentionModel'
import { Contract } from './contract'
import { DataBox } from './DataBox'
import { FollowUpRecords } from './FollowUpRecords'
import { PageHeader } from './PageHeader'

export function JoinIntention() {
    const { contractVisible, setContractVisible, choosedId, followUpRecordsVisible, setFollowUpRecordsVisible, choosedFranchiseeId } = useJoinIntention()
    return (
        <>
            <PageHeader />
            <DataBox />
            <Contract contractVisible={contractVisible} setContractVisible={setContractVisible} id={choosedId} />
            <FollowUpRecords followUpRecordsVisible={followUpRecordsVisible} setFollowUpRecordsVisible={setFollowUpRecordsVisible} franchiseeId={choosedFranchiseeId} />
        </>
    )
}
